<template>
    <div class="w-75 d-flex flex-column justify-center align-center mx-auto">
        <EmptyNotification class="w-50"></EmptyNotification>
        <span class="empty-list-subtitle text-subtitle-1 mt-1">
            <slot name="title">
                You dont have any Notifications.
            </slot>
        </span>
    </div>
</template>



<script setup>
import EmptyNotification from "@/icons/EmptyNotification.vue";
</script>